export const SUPPORTED_BROWSERS_PATH = 'supported-browsers';
export const SUPPORTED_BROWSERS_URL = `/${SUPPORTED_BROWSERS_PATH}`;
